// import React from "react";
// import { useNavigate } from "react-router-dom"; // Import useNavigate
// import OrderSteps from "../components/steps";
// import Footer from "../components/footer";
// import { FaWhatsapp } from "react-icons/fa"; // Import WhatsApp icon

// const Home = () => {
//   const navigate = useNavigate(); // Initialize useNavigate

//   const homeStyle = {
//     padding: "2rem",
//     backgroundImage: `
//       url("/background.png"), 
//       linear-gradient(to bottom, rgba(253,242,242,1), rgba(249,163,163,1))
//     `,
//     backgroundPosition: "center top, center bottom",
//     backgroundSize: "cover, 100% 100%",
//     backgroundRepeat: "no-repeat, no-repeat",
//     color: "#e94b4b",
//     minHeight: "80vh",
//     display: "flex",
//     flexDirection: "column",
//     alignItems: "flex-start",
//     justifyContent: "flex-start",
//     textAlign: "center",
//     paddingTop: "10rem",
//   };

//   const heroStyle = {
//     maxWidth: "800px",
//     textAlign: "left",
//   };

//   const headingStyle = {
//     fontSize: "4rem",
//     fontWeight: "bold",
//     color: "#e94b4b",
//   };

//   const subHeadingStyle = {
//     fontSize: "1rem",
//     marginBottom: "2rem",
//     color: "#000",
//     display: "block",
//   };

//   const heroButtonsContainerStyle = {
//     display: "flex",
//     gap: "1rem",
//     justifyContent: "flex-start",
//     width: "100%",
//     maxWidth: "800px",
//     paddingTop: "1rem",
//   };

//   const exploreBtnStyle = {
//     padding: "0.75rem 1.5rem",
//     border: "none",
//     fontSize: "1.2rem",
//     cursor: "pointer",
//     backgroundColor: "#d4a256",
//     color: "#fff",
//     width: 200,
//     borderRadius: "3%",
//     fontWeight: "bold",
//   };

//   const learnBtnStyle = {
//     padding: "0.75rem 1.5rem",
//     border: "2px solid #d4a256",
//     fontSize: "1.2rem",
//     cursor: "pointer",
//     backgroundColor: "#fff",
//     color: "#d4a256",
//     fontWeight: "bold",
//   };

//   // Functions to handle navigation
//   const handleExploreClick = () => {
//     navigate("/videos");
//   };

//   const handleLearnClick = () => {
//     navigate("/track");
//   };

//   return (
//     <>
//       <section style={homeStyle}>
//         <div style={heroStyle}>
//           <span style={headingStyle}>Your Event Invitations</span>
//           <span style={subHeadingStyle}>
//             Choose your stunning videos for your special occasions.
//           </span>
//           <div style={heroButtonsContainerStyle}>
//             <button style={exploreBtnStyle} onClick={handleExploreClick}>
//               See Videos
//             </button>
//             <button style={learnBtnStyle} onClick={handleLearnClick}>
//               Track Your Order
//             </button>
//           </div>
//         </div>
//       </section>
//       <section>
//         <OrderSteps />
//       </section>
//       <section>
//         <Footer />
//       </section>

//       {/* WhatsApp Order Button */}
//       <a
//         href="https://wa.me/919455588428" // Replace with your WhatsApp link
//         target="_blank"
//         rel="noopener noreferrer"
//         style={{
//           position: "fixed",
//           bottom: "30px",
//           right: "2px",
//           backgroundColor: "#4CAF50",
//           color: "#fff",
//           padding: "1rem 1.5rem",
//           borderRadius: "50px",
//           boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
//           textDecoration: "none",
//           display: "flex",
//           alignItems: "center",
//           gap: "0.5rem",
//           fontSize: 24
//         }}
//       >
//         <FaWhatsapp /> Order on WhatsApp
//       </a>
//     </>
//   );
// };

// export default Home;

import React from "react";
import { useNavigate } from "react-router-dom";
import OrderSteps from "../components/steps";
import Footer from "../components/footer";
import { FaWhatsapp } from "react-icons/fa";
import "./style.css"; // Import CSS file

const Home = () => {
  const navigate = useNavigate();

  // Functions to handle navigation
  const handleExploreClick = () => {
    navigate("/videos");
  };

  const handleLearnClick = () => {
    navigate("/track");
  };

  return (
    <>
      <section className="home">
        <div className="hero">
          <span className="heading">Your Event Invitations</span>
          <span className="sub-heading">
            Choose your stunning videos for your special occasions.
          </span>
          <div className="hero-buttons-container">
          <button className="explore-btn" onClick={handleExploreClick}>
              🎥 See Videos
            </button>
            <button className="learn-btn" onClick={handleLearnClick}>
              📦 Track Your Order
            </button>
          </div>
        </div>
      </section>
      <section>
        <OrderSteps />
      </section>
      <section>
        <Footer />
      </section>

      {/* WhatsApp Order Button */}
      <a
        href="https://wa.me/919455588428"
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-order-btn"
      >
        <FaWhatsapp /> Order on WhatsApp
      </a>
    </>
  );
};

export default Home;
